import { parsePhoneNumber } from 'react-phone-number-input/min';
import Cookies from 'js-cookie';
import analytics from '../../analytics';

export const SUBSCRIBE_COOKIE = 'SezanePopinOptinNewsletter';

/**
 * Normalizes a phone number entered as a prefix+national pair to E.164.
 * Handles trunk prefixes (e.g. '+33' + '0606060606' → '+33606060606').
 * Returns null if the input is not parseable or not a valid number.
 *
 * @param {string} phoneCode - Calling code prefix, e.g. '+33'
 * @param {string} phone     - National number, e.g. '0606060606'
 * @returns {string|null}    - E.164 number or null
 */
function normalizePhone(phoneCode, phone) {
  try {
    const parsed = parsePhoneNumber(phoneCode + phone);
    return parsed?.isValid() ? (parsed.number ?? null) : null;
  } catch {
    return null;
  }
}

function ajax(newsletterComponent) {
  const emailElement =
    newsletterComponent.querySelector('[name="email"]') || newsletterComponent.querySelector('input[type="email"]');
  const phoneCodeElement = newsletterComponent.querySelector('[name="phone_code"]');
  const phoneElement = newsletterComponent.querySelector('[name="phone"]');

  const button = newsletterComponent.querySelector('button');
  const phoneErrorMessage = document.getElementById('newsletter-phone-error');

  if (phoneElement) {
    phoneElement.addEventListener('input', () => {
      if (phoneErrorMessage) {
        phoneErrorMessage.style.display = 'none';
      }
    });
  }

  const alertDiv =
    newsletterComponent.parentNode?.querySelector('[role="alert"]') ||
    newsletterComponent.parentNode?.querySelector('[role="status"]') ||
    newsletterComponent.querySelector('[role="alert"]') ||
    newsletterComponent.querySelector('[role="status"]');
  const alertDivOriginalClasses = alertDiv?.getAttribute('class') || '';
  const alertDivOriginalRole = alertDiv?.getAttribute('role') || '';

  newsletterComponent.addEventListener('submit', (event) => {
    event.preventDefault();
    const email = emailElement?.value || null;
    const phoneCode = phoneCodeElement?.value || null;
    const phone = phoneElement?.value.trim() || null;
    const emailErrorMessage = document.getElementById('newsletter-email-error');
    const parsedPhone = phoneCode && phone ? normalizePhone(phoneCode, phone) : null;

    const showError = (el) => {
      if (el) {
        el.style.display = 'block';
      }
    };
    const hideError = (el) => {
      if (el) {
        el.style.display = 'none';
      }
    };

    let hasError = false;

    if (!email) {
      showError(emailErrorMessage);
      hasError = true;
    } else {
      hideError(emailErrorMessage);
    }

    if (phoneCode && phone && !parsedPhone) {
      showError(phoneErrorMessage);
      hasError = true;
    } else {
      hideError(phoneErrorMessage);
    }

    if (hasError) return;

    const brandName = document.documentElement.dataset.theme === 'octobre' ? 'octobre' : 'sezane';
    const defaultSubscription = [{ marketingBrandCode: brandName, status: true }];

    if (email) {
      const body = {
        email,
        emailSubscriptions: defaultSubscription,
        ...(parsedPhone && { phone: parsedPhone, smsSubscriptions: defaultSubscription }),
      };
      button.disabled = true;

      fetch(newsletterComponent.dataset.newsletterSubscribePath, {
        method: 'POST',
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (window.self !== window.top) {
            // iframe case :
            window.parent.postMessage(
              {
                event: 'GAevent',
                category: 'Newsletter_Subscription',
                action: newsletterComponent.dataset.actionTracking || 'Footer',
              },
              '*',
            );
          } else {
            // not iframe case :
            analytics.newsletterSubscription(email);
          }

          return response.json();
        })
        .then((responseJSON) => {
          // button.disabled = false;
          if (!alertDiv) return;

          // if they aren't errors we show the data value
          let errorMessage = responseJSON.data;
          // if they are errors we show the first one
          try {
            errorMessage = responseJSON.errors[0].title;

            alertDiv.setAttribute('class', `${alertDivOriginalClasses} u-color-error`);
            alertDiv.setAttribute('role', 'alert');
            button.disabled = true;
          } catch (error) {
            alertDiv.setAttribute('class', alertDivOriginalClasses);
            alertDiv.setAttribute('role', alertDivOriginalRole);
            Cookies.set(SUBSCRIBE_COOKIE, 1);
          }

          alertDiv.innerHTML = errorMessage;

          if (newsletterComponent.dataset.newsletterCallback === 'reload') {
            window.location.reload();
          }
        });
    }
  });
}

export default function ajaxSubscribeNewsletter() {
  const newsletterComponent = document.querySelector('*[data-component="newsletter_subscribe"]');
  if (newsletterComponent) {
    ajax(newsletterComponent);
  }
}
